import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20517 20517"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:none}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313088528">
        <path
          d="M5414 19947h9688c2665 0 4845-2180 4845-4844V5414c0-2664-2180-4844-4845-4844H5414C2750 570 570 2750 570 5414v9689c0 2664 2180 4844 4844 4844z"
          className="fill-none stroke1"
          style={{
            // stroke: "#2b2a29",
            strokeWidth: 1139.82,
          }}
        />
        <path
          d="M9561 4551c-246-166-388-411-388-668 0-482 486-873 1085-873 600 0 1086 391 1086 873 0 257-142 502-388 668"
          className="fill-none stroke1"
          style={{
            // stroke: "#2b2a29",
            strokeWidth: 1424.78,
          }}
        />
        <path
          d="m10775 4089-516-13h-1l-516 13c-2609 260-4653 2469-4653 5145v3476l-1477 2462c-96 160-99 359-7 521 92 163 264 262 450 262h4210c230 890 1032 1551 1993 1552h1c961-1 1762-662 1993-1552h4210c186 0 358-99 450-262 92-162 89-361-7-521l-1477-2462V9234c0-2676-2044-4885-4653-5145zm-517 1009h1c2280 1 4135 1856 4135 4137v3619c0 94 25 185 74 266l1080 1801H4968l1081-1801c48-81 74-172 74-266V9235c0-2281 1855-4136 4135-4137zm0 10857h889c-178 308-507 517-888 518h-1c-381-1-710-210-889-518h889z"
          style={{
            fill: "#2b2a29",
          }}
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
